import React from 'react';
import { useServiceClient } from 'common';
import { useQuery } from 'react-query';
import { MyAppsEndPoints, MyAppsQueryKey } from './query-enums';
import { ToCamelCasedKeys } from 'lib/types';

export interface IAppMetadataCased {
    Android: boolean;
    AppAutoNewVersion: string;
    AppBaseId: string;
    AppCompanyName: string;
    AppCompanyWebsite: string;
    AppCreatedBy: string;
    AppCreatedDate: string;
    AppDescription: string;
    AppDisplayName: string;
    AppDistributionList: string;
    AppId: string;
    AppInternalName: string;
    AppIsAutoDeploy: boolean;
    AppLastModifiedBy: string;
    AppLastModifiedDate: string;
    AppLockedBy: string;
    AppLockedDate: string;
    AppLogo: string;
    AppOwner: string;
    AppStatus?: number;
    AppVersion: string;
    LastBuildRequestedDate: string;
    Windows: boolean;
    iOS: boolean;
}

export type IAppMetadata = ToCamelCasedKeys<IAppMetadataCased>;

export const useGetMyAppQuery = () => {
    const { getData } = useServiceClient();
    const getMyApps = React.useCallback(() => getData(MyAppsEndPoints.GET_MY_APPS).then((res) => {
        if (res === null) {
            return [];
        }
        return res.json();
    }), [getData]);
    return useQuery<IAppMetadataCased[]>(MyAppsQueryKey.GET_MY_APPS, getMyApps);
};
